import {
  Component,
  ViewEncapsulation
} from '@angular/core';

import { MdDialogRef } from '@angular/material';
import { Util } from '../../../util/util';

export const DEFAULT_INPUTS_O_LIST_PICKER = [
  'data',
  'visibleColumns: visible-columns',
  'filter'
];


export class OListPickerDialogComponent {

  data: Array<any>;
  filter: boolean = true;

  visibleColsArray: Array<string>;
  searchVal : string;

  constructor(protected dialogRef: MdDialogRef<OListPickerDialogComponent>) { }

  initialize(parameters: Object): any {
    if (Util.isArray(parameters['data'])) {
      this.data = parameters['data'];
    }
    if (Util.isArray(parameters['visibleColumns'])) {
      this.visibleColsArray = parameters['visibleColumns'];
    }
    if (typeof parameters['filter'] !== 'undefined') {
      this.filter = parameters['filter'];
    }
  }

  onClickListItem(e: Event, value: any): void {
    this.dialogRef.close(value);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list-picker-dialog',
  template: `
    <md-toolbar color="primary" class="mat-elevation-z5" *ngIf="filter">
      <o-search-input class="list-picker-search" (onSearch)="searchVal=$event"></o-search-input>
    </md-toolbar>
    <div md-dialog-content class="dialog-list-container">
      <md-list>
        <md-list-item class="mat-1-line" (click)="onClickListItem($event, item)" fxFill
          *ngFor="let item of data | columnsfilter: {filtervalue: searchVal, filtercolumns: visibleColsArray }">
          <div fxLayout="column" fxFill>
            <div fxLayout="row" fxFill>
              <div #colWrapper *ngFor="let col of visibleColsArray" class="clip-text" fxFlex="auto">
                <p class="mat-list-item-text"> {{item[col]}} </p>
              </div>
            </div>
            <md-divider></md-divider>
          </div>
        </md-list-item>
      </md-list>
    </div>
    <md-dialog-actions align="end">
        <span fxFlex></span>
        <button md-button class="mat-primary" md-dialog-close>
          <span>{{ 'CANCEL' | oTranslate | uppercase }}</span>
        </button>
    </md-dialog-actions>
  `,
  styles: [`
    .input-model{display:none !important}.dialog-list-container md-list{margin:12px 0}.dialog-list-container md-list md-list-item{cursor:pointer}o-list-picker-dialog md-toolbar.mat-toolbar .mat-toolbar-row{padding-top:8px;box-sizing:content-box}o-list-picker-dialog md-toolbar o-search-input,o-list-picker-dialog md-toolbar o-search-input md-form-field{width:100%}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LIST_PICKER
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialogRef, },
];
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
